import { createSelector } from 'reselect';

export const getLoyaltyProgramDataSelector = createSelector(
  [state => state.loyaltyProgram.loyaltyData],
  loyaltyData => loyaltyData,
);
